import { BENCHMARK_PAGE_SIZE } from "./reportData"

const pageButtonClass =
  "h-9 cursor-pointer rounded-full bg-white px-3 text-[13px] font-normal leading-5 text-[#171717] shadow-[0_0_0_1px_rgba(0,0,0,0.08)] disabled:cursor-default disabled:text-[#8F8F8F]"

export default function PageControls({ page, total, onPage }) {
  if (!total || total <= BENCHMARK_PAGE_SIZE) return null
  const pages = Math.ceil(total / BENCHMARK_PAGE_SIZE)

  return (
    <nav className="flex flex-wrap items-center gap-3" aria-label="Pagination">
      <button
        type="button"
        className={pageButtonClass}
        disabled={page <= 1}
        onClick={() => onPage(page - 1)}
      >
        Previous
      </button>
      <p className="text-[14px] font-normal leading-5 text-[#4D4D4D]">
        {`Page ${page} of ${pages}`}
      </p>
      <button
        type="button"
        className={pageButtonClass}
        disabled={page >= pages}
        onClick={() => onPage(page + 1)}
      >
        Next
      </button>
    </nav>
  )
}
